import styled, { css } from 'styled-components';
import { media, layout } from 'src/components/base';

export const ProductListingItem = styled.div<{
  mode?: 'table' | 'grid' | 'row';
}>`
  min-width: 25%;
  flex: 1 1 25%;

  &.desktop-inline-ad,
  &.mobile-inline-ad-1,
  &.mobile-inline-ad-2,
  &.mobile-inline-ad-3 {
    display: none;
    flex: 1 1 100%;
  }

  ${media.mediumUp<{ mode?: 'grid' | 'table' | 'row' }>`
    ${props =>
      props.mode === 'grid' &&
      css`
        &.desktop-inline-ad {
          display: block;
          order: 3;
        }
      `}

    ${props =>
      props.mode === 'table' &&
      css`
        &.desktop-inline-ad {
          display: table-row;
          order: 3;
        }
      `}
  `}

  ${media.largeUp<{ mode?: 'grid' | 'table' | 'row' }>`
    ${props =>
      props.mode === 'grid' &&
      css`
        &.desktop-inline-ad {
          display: block;
          order: 4;
        }
      `}

    ${props =>
      props.mode === 'table' &&
      css`
        &.desktop-inline-ad {
          display: table-row;
          order: 4;
        }
      `}
  `}

  ${media.mediumDown<{ mode?: 'grid' | 'table' | 'row' }>`
    &.mobile-inline-ad-1 {
      display: block;
      order: 6;
    }

    ${props =>
      props.mode === 'row' &&
      css`
        &.mobile-inline-ad-2 {
          display: block;
          order: 21;
        }
      `}

    ${props =>
      props.mode === 'grid' &&
      css`
        min-width: 33%;
        flex: 1 1 33%;

        &.mobile-inline-ad-2 {
          display: block;
          order: 12;
        }

        &.mobile-inline-ad-3 {
          display: block;
          order: 18;
        }
      `}
  `}

  ${media.smallOnly<{ mode?: 'grid' | 'table' | 'row' }>`
    &.mobile-inline-ad-1 {
      display: block;
      order: 2;
    }

    ${props =>
      props.mode === 'row' &&
      css`
        &.mobile-inline-ad-2 {
          display: block;
          order: 14;
        }
      `}

    ${props =>
      props.mode === 'grid' &&
      css`
        min-width: 50%;
        flex: 1 1 50%;

        &.mobile-inline-ad-2 {
          display: block;
          order: 8;
        }

        &.mobile-inline-ad-3 {
          display: block;
          order: 14;
        }
      `}
  `}

  ${props =>
    props.mode === 'row' &&
    css`
      min-width: 100%;
      flex: 1 1 100%;
    `}

  ${props =>
    props.mode === 'table' &&
    css`
      display: table-row;

      > * {
        display: table-cell;
        // HACK: Without this, the first cell of the table will grow too much breaking the
        // whole layout. Max width prevents that behavior
        max-width: 10px;
      }

      ${media.smallOnly`
        &[class*='inline-ad'] {
          display: table-row;
        }
      `}
    `}
`;

export const ProductListingWrapper = styled.div<{
  $loading?: boolean;
  $mode?: 'table' | 'grid' | 'row';
}>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  opacity: 1;
  transition: opacity 0.5s;
  margin-bottom: 15px;
  list-style: none;
  line-height: 1.4;

  ${props =>
    props.$loading && props.$mode !== 'table'
      ? css`
          opacity: 0.5;
          transition: opacity 0.5s;
        `
      : undefined}

  ${props =>
    props.$mode === 'table'
      ? css`
          display: table;
          border-collapse: collapse;
          width: 100%;
        `
      : undefined}

  ${media.largeUp`
    & .desktop-inline-ad {
      display: block;
      min-width: 100%;
    }
  `}
`;

export const ProductListingTableBody = styled.div<{ $loading?: boolean }>`
  display: table-row-group;
  list-style: none;
  margin: 0;
  opacity: 1;
  transition: opacity 0.5s;

  ${props =>
    props.$loading
      ? css`
          opacity: 0.5;
          transition: opacity 0.5s;
        `
      : undefined}
`;

export const ProductListingInformation = styled.div`
  color: ${({ theme }) => theme.text.quaternary};
  font-size: ${layout.measurements.fontSizeSmall};
  font-style: italic;
  padding-top: ${layout.measurements.spacing150};
  padding-bottom: ${layout.measurements.spacing100};
`;

export const ProductListingFooter = styled.div`
  padding-top: ${layout.measurements.spacing100};
  padding-bottom: ${layout.measurements.spacing100};
`;
